export default function SectionCard({ title, icon, children, actions }: any) {
    return (
        <section className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm">
            <div className="mb-4 flex items-center justify-between">
                <h2 className="flex items-center gap-2 text-lg font-bold text-purple-900">
                    {icon} {title}
                </h2>
                {actions}
            </div>
            {children}
        </section>
    );
}